import {
  DashboardApiFp,
  DashboardControllerDashboard200Response,
  DashboardDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseDashboardModel = DashboardControllerDashboard200Response;
export type GetDashboardModel = DashboardDto;

export const apiDashboardFp = DashboardApiFp(apiConfig);
export const getDashboardController = apiDashboardFp.dashboardControllerDashboard;

export const QueryKeyDashboard = QueryKey.Dashboard;
